export enum DialogState {
  Open = 'opened',
  Opening = 'opening',
  Closing = 'closing',
  Closed = 'closed',
}
